const cseData1 = [
  // --- Easy-Hard Mix (1–20) ---
  {
    id: 1,
    category: "CSE",
    level: "easy",
    question: "What is the purpose of the HTML <head> tag?",
    options: [
      "To create hyperlinks",
      "To contain metadata and title of the page",
      "To style the page",
      "To display the main heading",
    ],
    answer: "To contain metadata and title of the page",
  },
  {
    id: 2,
    category: "CSE",
    level: "easy",
    question:
      "Which CSS property is used to control the spacing between letters?",
    options: ["word-spacing", "text-indent", "letter-spacing", "line-height"],
    answer: "letter-spacing",
  },
  {
    id: 3,
    category: "CSE",
    level: "easy",
    question: "Which HTML tag is used to define an unordered list?",
    options: ["<li>", "<ol>", "<ul>", "<list>"],
    answer: "<ul>",
  },
  {
    id: 4,
    category: "CSE",
    level: "easy",
    question: "Which JavaScript keyword declares a variable with block scope?",
    options: ["var", "const", "function", "let"],
    answer: "let",
  },
  {
    id: 5,
    category: "CSE",
    level: "easy",
    question: "In React, which hook is used for managing state?",
    options: ["useEffect", "useReducer", "useContext", "useState"],
    answer: "useState",
  },
  {
    id: 6,
    category: "CSE",
    level: "easy",
    question: "Which HTML element is used for inserting a line break?",
    options: ["<line>", "<lb>", "<br>", "<break>"],
    answer: "<br>",
  },
  {
    id: 7,
    category: "CSE",
    level: "easy",
    question: "What does CSS 'float' property do?",
    options: [
      "Centers the element",
      "Positions an element to the left or right",
      "Changes text color",
      "Adds margins",
    ],
    answer: "Positions an element to the left or right",
  },
  {
    id: 8,
    category: "CSE",
    level: "easy",
    question:
      "Which method is used to add an item to the end of an array in JavaScript?",
    options: ["shift()", "unshift()", "push()", "pop()"],
    answer: "push()",
  },
  {
    id: 9,
    category: "CSE",
    level: "easy",
    question: "Which HTML tag is used for the largest heading on a page?",
    options: ["<h6>", "<heading>", "<head>", "<h1>"],
    answer: "<h1>",
  },
  {
    id: 10,
    category: "CSE",
    level: "easy",
    question: "Which CSS property controls the transparency of an element?",
    options: ["z-index", "visibility", "opacity", "display"],
    answer: "opacity",
  },
  {
    id: 11,
    category: "CSE",
    level: "easy",
    question: "In JavaScript, what is the output of: `typeof NaN`?",
    options: ["undefined", "object", "NaN", "number"],
    answer: "number",
  },
  {
    id: 12,
    category: "CSE",
    level: "easy",
    question:
      "Which React hook is used to perform side effects such as fetching data?",
    options: ["useState", "useEffect", "useMemo", "useReducer"],
    answer: "useEffect",
  },
  {
    id: 13,
    category: "CSE",
    level: "easy",
    question: "Which HTML attribute is used to link an external CSS file?",
    options: ["rel", "link", "href", "src"],
    answer: "href",
  },
  {
    id: 14,
    category: "CSE",
    level: "easy",
    question: "What does SQL 'PRIMARY KEY' ensure?",
    options: [
      "Default value assigned",
      "Foreign table link",
      "Values are unique and not null",
      "Column is indexed",
    ],
    answer: "Values are unique and not null",
  },
  {
    id: 15,
    category: "CSE",
    level: "easy",
    question: "Which JavaScript function converts JSON text to an object?",
    options: [
      "JSON.object()",
      "JSON.convert()",
      "JSON.stringify()",
      "JSON.parse()",
    ],
    answer: "JSON.parse()",
  },
  {
    id: 16,
    category: "CSE",
    level: "easy",
    question: "Which HTTP status code indicates a successful request?",
    options: ["500", "404", "200", "302"],
    answer: "200",
  },
  {
    id: 17,
    category: "CSE",
    level: "easy",
    question: "In React, what is the purpose of the 'key' prop in lists?",
    options: [
      "Identify unique items for efficient rendering",
      "Set ID in database",
      "Handle clicks",
      "Style the list item",
    ],
    answer: "Identify unique items for efficient rendering",
  },
  {
    id: 18,
    category: "CSE",
    level: "easy",
    question: "Which database operation retrieves data without modifying it?",
    options: ["SELECT", "UPDATE", "DELETE", "INSERT"],
    answer: "SELECT",
  },
  {
    id: 19,
    category: "CSE",
    level: "easy",
    question: "Which CSS unit is relative to the font-size of the element?",
    options: ["em", "%", "px", "vh"],
    answer: "em",
  },
  {
    id: 20,
    category: "CSE",
    level: "easy",
    question: "Which JavaScript keyword prevents variable reassignment?",
    options: ["let", "final", "var", "const"],
    answer: "const",
  },

  // --- Hard Level (21–50) ---
  {
    id: 21,
    category: "CSE",
    level: "hard",
    question: "What are the four necessary conditions for a deadlock in an OS?",
    options: [
      "Paging, Segmentation, Swapping, Thrashing",
      "Mutual Exclusion, Hold and Wait, No Preemption, Circular Wait",
      "FIFO, LIFO, LRU, Optimal",
      "Concurrency, Atomicity, Isolation, Durability",
    ],
    answer: "Mutual Exclusion, Hold and Wait, No Preemption, Circular Wait",
  },
  {
    id: 22,
    category: "CSE",
    level: "hard",
    question: "What is database normalization?",
    options: [
      "Creating multiple backups",
      "Encrypting data",
      "Optimizing queries",
      "Reducing redundancy and organizing tables",
    ],
    answer: "Reducing redundancy and organizing tables",
  },
  {
    id: 23,
    category: "CSE",
    level: "hard",
    question: "What is the principle behind the Singleton design pattern?",
    options: [
      "Objects communicate via messages",
      "Methods are static",
      "Only one instance of a class exists",
      "Each class creates multiple instances",
    ],
    answer: "Only one instance of a class exists",
  },
  {
    id: 24,
    category: "CSE",
    level: "hard",
    question: "Which algorithm finds the shortest path in a weighted graph?",
    options: ["Prim", "Dijkstra", "Kruskal", "Bellman-Ford"],
    answer: "Dijkstra",
  },
  {
    id: 25,
    category: "CSE",
    level: "hard",
    question: "Difference between process and thread in an OS?",
    options: [
      "Process: program instance; Thread: subunit sharing memory",
      "Thread: program instance; Process: subunit",
      "Same thing",
      "Both run sequentially",
    ],
    answer: "Process: program instance; Thread: subunit sharing memory",
  },
  {
    id: 26,
    category: "CSE",
    level: "hard",
    question: "What is 'thrashing' in Operating Systems?",
    options: [
      "Spending more time swapping than executing",
      "Security attack",
      "Looped process",
      "CPU cache full",
    ],
    answer: "Spending more time swapping than executing",
  },
  {
    id: 27,
    category: "CSE",
    level: "hard",
    question: "What is a closure in JavaScript?",
    options: [
      "Browser window close",
      "Security vulnerability",
      "Function with access to parent scope even after parent finishes",
      "Function not in use",
    ],
    answer: "Function with access to parent scope even after parent finishes",
  },
  {
    id: 28,
    category: "CSE",
    level: "hard",
    question: "Explain the purpose of ACID properties in databases.",
    options: [
      "Backup creation",
      "Ensure reliable transactions",
      "Fast queries",
      "Index optimization",
    ],
    answer: "Ensure reliable transactions",
  },
  {
    id: 29,
    category: "CSE",
    level: "hard",
    question: "What is the event loop in JavaScript?",
    options: [
      "Loops through arrays",
      "CSS animation loop",
      "Allows non-blocking asynchronous code execution",
      "React feature",
    ],
    answer: "Allows non-blocking asynchronous code execution",
  },
  {
    id: 30,
    category: "CSE",
    level: "hard",
    question: "Difference between 'var', 'let', and 'const' in JavaScript?",
    options: [
      "Scope and reassignment rules differ",
      "All same",
      "Only 'var' works in HTML",
      "Const allows reassignment",
    ],
    answer: "Scope and reassignment rules differ",
  },
  {
    id: 31,
    category: "CSE",
    level: "hard",
    question: "What is the CAP theorem in distributed systems?",
    options: [
      "Consistency, Availability, Partition tolerance (2 of 3 possible)",
      "Network capacity",
      "Security protocol",
      "CPU, Access, Power",
    ],
    answer: "Consistency, Availability, Partition tolerance (2 of 3 possible)",
  },
  {
    id: 32,
    category: "CSE",
    level: "hard",
    question: "What is SQL Injection?",
    options: [
      "Code injection to manipulate DB",
      "Adding JavaScript to SQL",
      "Query optimization",
      "Faster DB query",
    ],
    answer: "Code injection to manipulate DB",
  },
  {
    id: 33,
    category: "CSE",
    level: "hard",
    question: "Difference between supervised and unsupervised learning?",
    options: [
      "Supervised: labeled data; Unsupervised: unlabeled",
      "No difference",
      "Unsupervised needs supervision",
      "Supervised always faster",
    ],
    answer: "Supervised: labeled data; Unsupervised: unlabeled",
  },
  {
    id: 34,
    category: "CSE",
    level: "hard",
    question: "Which sorting algorithm uses divide and conquer?",
    options: ["Insertion Sort", "Merge Sort", "Selection Sort", "Bubble Sort"],
    answer: "Merge Sort",
  },
  {
    id: 35,
    category: "CSE",
    level: "hard",
    question: "Which data structure uses LIFO?",
    options: ["Stack", "Queue", "Array", "Tree"],
    answer: "Stack",
  },
  {
    id: 36,
    category: "CSE",
    level: "hard",
    question: "Which data structure uses FIFO?",
    options: ["Queue", "Tree", "Stack", "Graph"],
    answer: "Queue",
  },
  {
    id: 37,
    category: "CSE",
    level: "hard",
    question: "Explain the purpose of the 'key' prop in React lists.",
    options: [
      "Styles the list",
      "Database primary key",
      "Helps React efficiently update list items",
      "Event handling",
    ],
    answer: "Helps React efficiently update list items",
  },
  {
    id: 38,
    category: "CSE",
    level: "hard",
    question: "What is a binary search tree (BST)?",
    options: [
      "Balanced graph",
      "Tree with left child < parent < right child",
      "Linked list variant",
      "Array sorted",
    ],
    answer: "Tree with left child < parent < right child",
  },
  {
    id: 39,
    category: "CSE",
    level: "hard",
    question: "What is 'props drilling' in React?",
    options: [
      "Passing props through multiple components",
      "State management library",
      "API request method",
      "CSS styling technique",
    ],
    answer: "Passing props through multiple components",
  },
  {
    id: 40,
    category: "CSE",
    level: "hard",
    question: "What is the purpose of useReducer hook in React?",
    options: [
      "Manage complex state logic",
      "Perform side effects",
      "Optimize render",
      "Replace CSS",
    ],
    answer: "Manage complex state logic",
  },
  {
    id: 41,
    category: "CSE",
    level: "hard",
    question: "Which algorithm detects cycles in a graph?",
    options: ["DFS", "BFS", "Dijkstra", "Kruskal"],
    answer: "DFS",
  },
  {
    id: 42,
    category: "CSE",
    level: "hard",
    question: "Explain 'normal form' in databases.",
    options: [
      "Rules to reduce redundancy and dependency",
      "Backup rules",
      "Encryption rules",
      "Sorting rules",
    ],
    answer: "Rules to reduce redundancy and dependency",
  },
  {
    id: 43,
    category: "CSE",
    level: "hard",
    question: "What is the virtual DOM in React?",
    options: [
      "Actual HTML",
      "Lightweight copy of real DOM for faster rendering",
      "CSS framework",
      "JavaScript library for 3D",
    ],
    answer: "Lightweight copy of real DOM for faster rendering",
  },
  {
    id: 44,
    category: "CSE",
    level: "hard",
    question: "Which is an idempotent HTTP method?",
    options: ["GET", "POST", "PATCH", "DELETE"],
    answer: "GET",
  },
  {
    id: 45,
    category: "CSE",
    level: "hard",
    question: "What is the R-squared value in regression analysis?",
    options: [
      "Variance explained by independent variables",
      "Average dependent variable",
      "Slope of line",
      "Number of observations",
    ],
    answer: "Variance explained by independent variables",
  },
  {
    id: 46,
    category: "CSE",
    level: "hard",
    question: "Which technique is used to detect outliers?",
    options: ["Z-score", "Mean", "Sorting", "Mode"],
    answer: "Z-score",
  },
  {
    id: 47,
    category: "CSE",
    level: "hard",
    question: "What is the difference between stack and heap memory?",
    options: [
      "Stack: LIFO & small, Heap: dynamic allocation",
      "Stack is larger",
      "Heap is faster",
      "No difference",
    ],
    answer: "Stack: LIFO & small, Heap: dynamic allocation",
  },
  {
    id: 48,
    category: "CSE",
    level: "hard",
    question:
      "Which design pattern is used for object creation without exposing creation logic?",
    options: ["Singleton", "Factory Pattern", "Observer", "Adapter"],
    answer: "Factory Pattern",
  },
  {
    id: 49,
    category: "CSE",
    level: "hard",
    question: "Which JavaScript method merges two arrays?",
    options: ["merge()", "join()", "concat()", "push()"],
    answer: "concat()",
  },
  {
    id: 50,
    category: "CSE",
    level: "hard",
    question: "Which algorithm is used for topological sorting of a DAG?",
    options: ["Kahn's Algorithm", "Dijkstra", "Prim", "DFS traversal"],
    answer: "Kahn's Algorithm",
  },
];

export default cseData1;
